export default __webpack_public_path__ + "static/background-default-5effbe9cb0c74142c8d5260aec0b9f0c.jpg";